import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset. Please log in.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-6">
      <div className="w-full max-w-md">
        <Logo size="md" />
        <h1 className="mt-12 text-4xl font-display font-semibold tracking-tight">Set a new password</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white border border-[#E5E5E5] rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C86B53]/20 focus:border-[#C86B53] transition"
            placeholder="New password"
          />
          <button type="submit" disabled={busy || !token} className="neivai-btn-primary w-full disabled:opacity-60">
            {busy ? "Resetting…" : "Reset password"}
          </button>
          <Link to="/login" className="block text-center text-sm text-[#5C5F62] hover:text-[#1A1C1E]">Back to login</Link>
        </form>
      </div>
    </div>
  );
}
